export const apiLoginUser = process.env.REACT_APP_LOGINUSER;
export const apiLogoutUser = process.env.REACT_APP_LOGOUTUSER;
export const apiRefresh = process.env.REACT_APP_REFRESH;
